import React from 'react'
import { IconButton, HistoryIcon, useModal } from '@nominex/dex-uikit'
// import { SlButton } from '@shoelace-style/shoelace/dist/react'
// import { useTranslation } from 'contexts/Localization'
import TransactionsModal from './TransactionsModal'

const Transactions = () => {
  const [onPresentTransactionsModal] = useModal(<TransactionsModal />)
  // const { t } = useTranslation()

  return (
    <>
      {/* <SlButton variant="text" onClick={onPresentTransactionsModal} size="small">
        {t('Transactions')}
      </SlButton> */}
      <IconButton onClick={onPresentTransactionsModal} variant="text" scale="sm">
        <HistoryIcon height={20} width={20} color="textSubtle" />
      </IconButton>
    </>
  )
}

export default Transactions
